import { cva } from "class-variance-authority";

export const segmentVariants = cva(
  "inline-flex flex-col items-center justify-center px-2.5 py-0.5 first:rounded-l-[10px] last:rounded-r-[10px]",
  {
    variants: {
      status: {
        success: "bg-green-50 text-green-700 border-green-200",
        warning: "bg-yellow-50 text-yellow-700 border-yellow-200",
        error: "bg-red-50 text-red-700 border-red-200",
        alert: "bg-orange-100 text-orange-700 border-orange-300",
        neutral: "bg-gray-50 text-gray-700 border-gray-200",
      },
    },
    defaultVariants: {
      status: "neutral",
    },
  }
);
